import React from 'react';

export type PageTitleProps = {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLHeadingElement>;

export const PageTitle: React.FC<PageTitleProps> = ({ children, ...rest }) => (
  <h2
    {...rest}
    className={`b-title${rest.className ? ` ${rest.className}` : ''}`}
    style={{ marginLeft: 0, marginRight: 0 }}
  >
    {children}
  </h2>
);
